import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { EstimativaNovaComponent } from './estimativa-nova.component';
import { EstimativaGerenciarColaboradorComponent } from './estimativa-gerenciar-colaborador/estimativa-gerenciar-colaborador.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    EstimativaNovaComponent,
    EstimativaGerenciarColaboradorComponent
  ],
  imports: [
    SharedModule,
    MatSlideToggleModule,
   // NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
  ]
})
export class EstimativaModule { }
